import { useAppDispatch } from '@/hooks';
import { closeAllDrawers } from '@/modules/appContext';
import React from 'react';
import { HoverableCloseButton } from '@/components/buttons';

export const CloseButton = () => {
  const dispatch = useAppDispatch();

  const closeAll = () => {
    dispatch(closeAllDrawers());
  };

  return (
    <HoverableCloseButton
      onClick={closeAll}
      sx={{
        position: 'absolute',
        right: '4px',
        top: '4px'
      }}
    />
  );
};
